import { ON_CHANGE_STYLE_PARAM } from '../constants';
import { reloadAllGallery } from './gallery/galleryHeight';
import { getAllHashtagsItems } from './services/hashtagService';
import {
  convertStyleParams,
  getDefaultParams,
  isInstagramV4,
  getIsFullWidth,
} from './more/migration';
import store from '../store';

export const updateStyle = (style) => async (dispatch) => {
  const { sortHashtagsFeed } = store.getState().settingsReducer;
  let styles = {
    ...style.colors,
    ...style.numbers,
    ...style.fonts,
    ...style.booleans,
  };
  const isV4 = await isInstagramV4(styles);
  console.log('isV4', isV4);
  if (isV4) {
    await getIsFullWidth();
    styles.isV4Styles = true;
    const newDefaultStyles = {},
      newMigrationStyles = {};
    getDefaultParams().forEach(({ newKey, value }) => {
      newDefaultStyles[newKey] = value;
    });

    Object.keys(styles).forEach((key) => {
      convertStyleParams(key, styles[key]).forEach(({ newKey, value }) => {
        newMigrationStyles[newKey] = value;
      });
    });
    styles = {
      ...styles,
      ...newDefaultStyles,
      ...newMigrationStyles,
    };
  }

  dispatch({
    type: ON_CHANGE_STYLE_PARAM,
    payload: styles,
  });

  dispatch(checkIfHashtahSortChanged(style.numbers, sortHashtagsFeed));
  dispatch(reloadAllGallery());
};

const checkIfHashtahSortChanged = (newStyle, oldSortHashtags) => (dispatch) => {
  const { hashtags } = store.getState().appReducer;
  const newSortHashtags = newStyle && newStyle.sortHashtagsFeed;

  if (oldSortHashtags !== newSortHashtags && hashtags && hashtags.length) {
    dispatch(getAllHashtagsItems(hashtags));
  }
};
